import React from 'react';
import _ from 'lodash';
import {observer} from 'mobx-react';

@observer class Accordion extends React.Component {
  container;

  getMaxHeight = () => {
    if (this.props.active && !this.container) return 'none';
    return this.props.active ? this.container.offsetHeight : 0;
  }

  render() {
    const {children} = this.props;

    return (
      <div className='Accordion-menu' style={{maxHeight: this.getMaxHeight()}}>
        <div className='Accordion-container' ref={container => this.container = container}>
          {children}
        </div>
      </div>
    );
  }
}

export default Accordion;
